import { apiClient } from './api';

function unwrapData<T>(
  res: { success: boolean; data?: T; message?: string; error?: string },
  fallbackMsg: string,
): T {
  if (!res.success || res.data === undefined) {
    throw new Error(res.message || res.error || fallbackMsg);
  }
  return res.data;
}

export const shippingService = {
  async list(): Promise<Record<string, unknown>[]> {
    const res = await apiClient.get<Record<string, unknown>[]>('/admin/shipping-methods');
    return unwrapData(res, 'خطا در دریافت روش‌های ارسال');
  },
  async create(data: Record<string, unknown>): Promise<Record<string, unknown>> {
    const res = await apiClient.post<Record<string, unknown>>('/admin/shipping-methods', data);
    return unwrapData(res, 'ایجاد روش ارسال ناموفق بود');
  },
  async update(id: string, data: Record<string, unknown>): Promise<Record<string, unknown>> {
    const res = await apiClient.put<Record<string, unknown>>(`/admin/shipping-methods/${id}`, data);
    return unwrapData(res, 'ویرایش روش ارسال ناموفق بود');
  },
  async remove(id: string): Promise<void> {
    const res = await apiClient.delete(`/admin/shipping-methods/${id}`);
    if (!res.success) throw new Error(res.message || 'حذف روش ارسال ناموفق بود');
  },
};
